import { withInstall } from "../utils/index.mjs";
import _NavBar from "./NavBar.mjs";
const NavBar = withInstall(_NavBar);
var stdin_default = NavBar;
import { navBarProps } from "./NavBar.mjs";
export {
  NavBar,
  stdin_default as default,
  navBarProps
};
